<template>
  <div class="header" :class="{ 'before-header': tabbarBoxFixed }">
    <div class="header-logo">
      <img src="../assets/images/logo.png" class="logo" />
      <div>天科智友</div>
    </div>

    <div class="menuList">
      <div
        v-for="(item, index) in menuList"
        :key="index"
        @click="onMenu(index)"
        class="menu"
        :class="{ 'before-menu': menuIndex === index }"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="tel">400-650-1132</div>
  </div>
</template>

<script>
import { ref, reactive, watch, onMounted } from "vue";
import { useRouter } from "vue-router";
export default {
  name: "Header",
  props: ["tabbarBoxFixed"],
  setup(props) {
    console.log("props:", props.tabbarBoxFixed);
    const router = useRouter();
    onMounted(() => {
      nowRouter();
    });

    const nowRouter = () => {
      const path = window.location.hash.slice(1, window.location.hash.length);
      var nowIndex = menuList.findIndex((item, index) => {
        console.log("path;", path, item.path);
        return item.path == path;
      });
      if (nowIndex >= 0) {
        menuIndex.value = nowIndex;
      }
    };

    var menuIndex = ref(0);
    console.log("传参:", props);
    const menuList = [
      {
        name: "首页",
        path: "/",
      },
      {
        name: "业务介绍",
        path: "/business",
      },
      {
        name: "系统介绍",
        path: "/introduction",
      },
       {
        name: "产品介绍",
        path: "/product",
      },
      {
        name: "联系我们",
        path: "/contactus",
      },
    ];
    const onMenu = (index) => {
      menuIndex.value = index;
      router.push(menuList[index].path);
    };
    watch(
      () => router.currentRoute.value,
      (newValue) => {
        document.documentElement.scrollTop = 0;
        nowRouter();
      },
      { immediate: true }
    );
    return {
      menuList,
      menuIndex,
      onMenu,
    };
  },
};
</script>
<style scoped lang="scss">
.header {
  width: 100%;
  min-width: 1280px;
  height: 90px;
  background: transparent;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
  transition: 0.5s;
}
.before-header {
  position: fixed;
  box-shadow: 5px 5px 10px #eee;
  left: 0;
  top: 0;
  background: white;
  transition: 0.5s;
  z-index: 50;
}
.header-logo {
  display: flex;
  position: absolute;
  left: 7.5%;
  top: 28px;
  .logo {
    width: 40px;
    height: 35px;
  }
  div {
    line-height: 35px;
    font-size: 18px;
    margin-left: 10px;
    font-family: pingfangB;
  }
}

.menuList {
  display: flex;
  position: absolute;
  top: 40px;
  right: 25%;
  font-size: 16px;
  font-family: pingfangB;
  cursor: pointer;
  .menu {
    margin-right: 50px;
    border-bottom: 4px solid transparent;
    height: 28px;
    padding: 0 10px;
    &:hover {
      border-bottom: 4px solid;
      border-image-source: linear-gradient(to right, #0088c0, #41b8a2);
      border-image-slice: 1;
    }
  }
  .before-menu {
    margin-right: 50px;
    border-bottom: 4px solid;
    border-image-source: linear-gradient(to right, #0088c0, #41b8a2);
    border-image-slice: 1;
  }
}
.tel {
  position: absolute;
  width: auto;
  font-size: 18px;
  font-family: pingfangB;
  color: white;
  top: 30px;
  right: 7.5%;
  border-radius: 25px;
  width: 12%;
  height: 45px;
  line-height: 45px;
  background-image: linear-gradient(to right, #0087bf, #25a5ae);
}
</style>
